module.exports = __webpack_public_path__ + "img/questions.2d3bb674.svg";